<template>
    <div class="container" style="">
        <section>
            <h4>漯河市公共资源交易统一身份认证平台（登录）</h4>
            <div class="center-cont">
                <div class="login_box">
                <div class="login_title">
                    <span
                        v-for="(item,index) in loginTypeList"
                        :key="index"
                        :class="loginTypeActive == index ? 'active' : null"
                        @click="changeLoginType(index)"
                    >
                        {{ item }}
                    </span>
                </div>
                <div v-if="loginTypeActive == 0" class="login-type">
                    <div class="login_cont"></div>
                    <button style="width: 80%" @click="CALogin">立即登录</button>
                </div>
                <div v-if="loginTypeActive == 3" class="login-type">
                    <div class="login_QRcode">
                        <img :src="imgurl" alt="">
                    </div>
                </div>
                <div v-if="loginTypeActive == 1" class="login-type">
                    <div class="login-input">
                        <p v-if="loginTypeFlag" class="user-type">
                            <span @click="changeUserType(0)">自然人</span>
                            <span @click="changeUserType(1)">法人</span>
                            <span @click="changeUserType(2)">管理员</span>( 开发使用 )
                        </p>
                        <p style="color: red;text-align: left;font-size: 13px;height: 32px;line-height: 32px">
                            账号登录仅支持工作人员使用，各自然人、企业等交易主体请使用CA登录
                        </p>
                        <el-form 
                            ref="dataForm" :model="dataForm" :rules="dataRule"
                            status-icon
                            @keyup.enter.native="dataFormSubmit()"
                        >
                            <el-form-item prop="usernameForInput">
                                <el-input 
                                    v-model="dataForm.usernameForInput" clearable
                                    placeholder="账号"
                                    prefix-icon="el-icon-user"
                                ></el-input>
                            </el-form-item>
                            <el-form-item prop="passwordForInput">
                                <el-input 
                                    v-model="dataForm.passwordForInput" clearable placeholder="密码"
                                    prefix-icon="el-icon-lock"
                                    show-password type="password"
                                ></el-input>
                            </el-form-item>
                            <el-form-item prop="captcha">
                                <el-row>
                                    <el-col :span="13">
                                        <el-input v-model="dataForm.captcha" placeholder="验证码">
                                    </el-input>
                                    </el-col>
                                    <el-col :span="10" class="login-captcha">
                                        <img :src="captchaPath" alt="" style="margin-left:33px;height: 40px" @click="getCaptcha()">
                                    </el-col>
                                </el-row>
                            </el-form-item>
                            <el-button class="login-btn radius3" style="padding: 0px 0px;" type="primary"
                                    @click="dataFormSubmit()">登录
                            </el-button>
                        </el-form>
                    </div>
                </div>
                <div v-if="loginTypeActive == 2" class="login-type">
                    <div class="login-code"> </div>
                </div>
                <p style="width:100%;cursor:pointer;text-align: center;color: rgba(0,0,0,.65);font-size: 14px;margin-top: 15px;margin-bottom: 10px">
                    登录即代表您已同意
                    <router-link :to="'/userNotice'" class="notice" target="_blank">
                        <span>《漯河公共市场主体用户须知》</span>
                    </router-link>
                </p>
                <!-- <p style="width:100%;cursor:pointer;text-align: left;color: #4D69F6;margin-top: 15px;padding: 0 0 0 35px" @click="toRegister">还没注册？点这里~</p> -->
                <div class="other_login_way">
                    <div class="other_login_tips">
                        <div class="line_left"></div>
                        其他登录方式
                        <div class="line_right"></div>
                    </div>
                    <div class="login_choose">
                        <!-- <div class="unified_login" @click="unified_login">全省统一登录账号</div> -->
                        <div v-if="login_switch" class="other_login" @click="other_login">电子营业执照登录</div>
                        <div v-if="account_switch" class="other_login" @click="account_login">漯河市主体账号登录</div>
                    </div>

                </div>

                </div>
                <div class="center-tips">
                    <h4>平台帮助</h4>
                    <ul>
                        <li v-for="(item,index) in questionList" :key="index" :title="item.title" @click="toDetail(item,index)">
                            <i></i>
                            {{ item.title }}
                        </li>
                        <!-- <router-link class="notice" target="_blank" :to="{name:'questionDiscretionDetail',params:{item:item,index:index}}">
                            {{item.title}}
                        </router-link> -->
                    </ul>
                    <p>
                        <a href="https://cjdown.oss.aliyuncs.com/lh/品茗驱动（河南互认）V1.5.exe"><span><i></i>驱动下载</span></a>
                        <!-- <a href="https://cms.lhjs.cn/public/dfdeb253e2db40d1a19a987fc04db790/pm_luohe_media/202108/1627981746530000.exe"><span><i></i>投标工具下载</span></a> -->
                    </p>
                </div>
            </div>
            <div class="step-tips">
                主体库办理流程：办理CA数字证书——使用CA数字证书登录——完善主体信息并提交——入库成功
            </div>
        </section>
        <el-dialog :visible.sync="dialogVisibleFlag" width="660px">
            <div slot="title" class="dialog-title">
                <i class="el-icon-warning-outline" style="font-size: 20px;color: #FF9A2C;margin: 0 9px 0 0"></i>
                <span class="title-text" style="font-size: 18px;color: #FF9A2C">温馨提示</span>
                <div class="button-right">
                    <span class="title-close" @click="cancelDialog"></span>
                </div>
            </div>
            <div>
                <p style="color: #000000;margin: 0 0 8px 0;">检测到未使用IE浏览器访问本网站，为保障您的正常使用，请提前做如下操作：</p>
                <p style="color: rgba(0, 0, 0, 0.45);">1、<a href="http://cjdown.oss.aliyuncs.com/lh/品茗驱动（河南互认）V1.5.exe"
                                                            style="color: #1890FF">下载</a>并完整安装驱动（已安装可忽略）
                </p>
                <p style="color: rgba(0, 0, 0, 0.45);">2、使用IE浏览器访问本网站，或含IE内核浏览器且切换至兼容模式，切换方式如下图：</p>
                <img alt="" src="../../assets/img/lh-login/login-tips.png" style="margin: 24px 0;">
                <p style="color: rgba(0, 0, 0, 0.45);">含IE内核的浏览器主要有：360浏览器、QQ浏览器、猎豹浏览器、百度浏览器等。</p>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" style="margin: 0 42px 0 0" type="primary" @click="dialogVisibleFlag = false">我知道了</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {initCa, getCaInfo, SignData} from '../../plugins/pmca'
import {getUUID} from '../../utils/index'
import {logoutWithoutRedirect} from '@/utils/login'
import axios from 'axios'
import Crypto from '@/utils/crypto'
import {isURL} from '@/utils/validate'

const ssoHttp = axios.create({
    timeout: 1000 * 30,
    withCredentials: true,
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json; charset=utf-8'
    }
})
// ssoHttp.interceptors.request.use(
//     config => {
//         config.params = {...config.params, timestamp: Date.now()};
//         config.headers.Authorize = localStorage.getItem('token') || '';
//         return config
//     },
//     error => Promise.reject(error)
// );

export default {
    data() {
        return {
            loginTypeFlag: false,
            dialogVisibleFlag: false,
            dataForm: {
                usernameForInput: '',
                passwordForInput: '',
                uuid: '',
                captcha: ''
            },
            captchaPath: '',
            dataRule: {
                usernameForInput: [
                {required: true, message: '账号不能为空', trigger: 'blur'}
                ],
                passwordForInput: [
                {required: true, message: '密码不能为空', trigger: 'blur'}
                ],
                captcha: [
                {required: true, message: '验证码不能为空', trigger: 'blur'}
                ]
            },
            loginTypeList: ['CA登录', '账号登录'],
            // loginTypeList: [],
            loginTypeActive: 0,
            //ca绑定
            CAData: {
                username: '',
                password: '',
                captcha: '',
                caCode: '',
                friendlyName: '',
                expireDate: '',
                fromDate: '',
                remark: '',
            },
            //CA
            CAInfo: {
                signData: '',
                loginType: 1,
                caCode: '',
                appId: this.appCode,
                contaillAppList: this.appCode == 1 ? false : true,
                caLegalCode: '',//社会信用代码
                friendlyName: '',
                fromDate: '',//有效期开始时间
                expireDate: '',//有效期结束时间
                caName: '',
                appCode: '',
                signCert: '',
                password: 'CA',
                username: 'CA',
                useCaptcha: 1,
                backUrl: '',
                legalCode: ''
            },
            questionList: [],
            login_switch: true,
            account_switch: false,
            imgurl: null,
            qrid: null,
            oauthInfo: {
                redirect_uri:'',
                client_id:'',
                scope:'',
                state:'',
                response_type:'',
            }
        }
    },
    // created() {
    //     this.appCode = this.$route.params.appCode
    //     this.backUrl = this.$route.query.redirect_uri
    //     let logout = this.$route.query.logout
    //     let oauth = this.$route.query.oauth
    //     if (!isURL(this.backUrl)) {
    //         this.$router.push({name: 'authorize-error'})
    //         return
    //     }
    //     let type = this.$route.params.type
    //     if (oauth === 2 || oauth === '2') {
    //         type = 2
    //     }
    //     if (logout === '1') {
    //         this.LoginFormVisible = true
    //         let _self = this
    //         if (this.appCode !== '1') {
    //             //外部系统退出时，需要报基础平台也退出处理掉
    //             logoutWithoutRedirect(function (data) {
    //                 _self.getCaptcha()
    //             })
    //         } else {
    //             this.getCaptcha()
    //         }
    //     } else if (type === 1 || type === '1') {
    //         this.LoginFormVisible = true
    //         this.getCaptcha()
    //     } else if (type === 2 || type === '2') {
    //         this.loadByCookie(true)
    //     } else {
    //         this.LoginFormVisible = true
    //         this.getCaptcha()
    //     }
    //     if (this.isIEBrowser()) {
    //         this.dialogVisibleFlag = true
    //     }
    //     this.getCaptcha()
    //     this.getToken()
    //     this.onlineService()
    //     this.getPlatformHelp()
    //     if (process.env.NODE_ENV !== 'production') {
    //         this.loginTypeFlag = true
    //     }
    // },
    created() {
        this.appCode = this.$route.params.appCode;
        this.backUrl = this.$route.query.redirect_uri;
        // let logout = this.$route.query.logout;
        // let oauth = this.$route.query.oauth;
        Object.keys(this.oauthInfo).forEach(key => {
            this.oauthInfo[key] = this.$route.query[key];
        })
        console.log(this.oauthInfo)
        if (this.isIEBrowser()) {
            this.dialogVisibleFlag = true;
        }
        this.getCaptcha();
        this.onlineService();
        this.getPlatformHelp();
    },
    methods: {
        cancelDialog() {
            this.dialogVisibleFlag = false
        },
        //判断是否为IE内核浏览器
        isIEBrowser() {
            var u = window.navigator.userAgent.toLocaleLowerCase()
            var msie = /(msie) ([\d.]+)/
            var chrome = /(chrome)\/([\d.]+)/
            var firefox = /(firefox)\/([\d.]+)/
            var safari = /(safari)\/([\d.]+)/
            var opera = /(opera)\/([\d.]+)/
            var ie11 = /(trident)\/([\d.]+)/
            var b = u.match(msie) || u.match(chrome) || u.match(firefox) || u.match(safari) || u.match(opera) || u.match(ie11)
            if (b[1] == 'msie' || b[1] == 'trident') {
                return false
            } else {
                return true
            }
        },
        changeUserType(val) {
            if (val == 0) {
                this.dataForm.usernameForInput = 'csreg002'
                this.dataForm.passwordForInput = 'Pm15224010203'
            } else if (val == 1) {
                this.dataForm.usernameForInput = 'pm91371321MA3D54EL36'
                this.dataForm.passwordForInput = 'Pm15224010203'
            } else {
                this.dataForm.usernameForInput = 'supperadmin'
                this.dataForm.passwordForInput = 'Pm180827'
            }
        },
        // 提交表单
        dataFormSubmit() {
            this.$refs['dataForm'].validate((valid) => {
                if (valid) {
                this.$http.post('/oauth/login', {
                    'backUrl': '',
                    'loginType': 0,
                    'useCaptcha': 1,
                    // 'appCode': this.appCode,
                    // 'appId': this.appCode,
                    'contaillAppList': this.appCode == 1 ? false : true,
                    'username': this.dataForm.usernameForInput,
                    'password': Crypto.encrypt(this.dataForm.passwordForInput),
                    'uuid': this.dataForm.uuid,
                    'captcha': this.dataForm.captcha
                }).then(({data}) => {
                    if (data.code == '1') {
                        this.loginByJwt(data.authCode)
                        localStorage.setItem('token', data.authCode)
                    } else {
                        this.getCaptcha()
                        this.$message.error(data.msg)
                    }
                })
                }
            })
        },
        changeLoginType(index) {
            // this.loginTypeActive = index;
            if (this.loginTypeList.length >= 2) {
                this.loginTypeActive = index
            } else {
                this.loginTypeActive = 0
            }
        },
        //初始化CA
        CALogin() {
            initCa((isIE) => {
                if (!isIE) {
                alert('初始化验证失败，请使用ie浏览器登录并检查ie配置项!')
            }
        })
        getCaInfo((certInfo) => {
                // this.CAInfo.traddingOrgId = this.$cookie.get('traddingOrgId'),
                this.CAInfo.caCode = certInfo.certserial,
                this.CAInfo.legalCode = certInfo.caLegalCode,
                this.CAInfo.friendlyName = certInfo.friendlyName,
                this.CAInfo.fromDate = certInfo.validstarttime,
                this.CAInfo.expireDate = certInfo.validendtime,
                this.CAInfo.caName = certInfo.certName
                this.CAInfo.appCode = this.appCode
            })
            this.affirmCA()
        },
        //ca登录
        affirmCA() {
            this.CAInfo.signData = SignData()
            if (!this.CAInfo.signData) {
                this.$alert('请确认河南CA的UKEY是否正确插入', '提示', {
                confirmButtonText: '确定',
                })
                return
            }
            this.$http.post('/oauth/login', this.CAInfo).then(({data}) => {
                if (data && data.code === '1') {
                    this.loginByJwt(data.authCode)
                    localStorage.setItem('token', data.authCode)
                } else if (data.code === '9002') {//CA未绑定或绑定的用户不存在
                    ssoHttp.post(`/proxyApi/sys/login`, this.CAInfo).then(({data}) => {
                        if (data.code === '1') {
                            this.$http.post(`/oauth/login`, this.CAInfo).then(({data}) => {
                                if (data.code === '1') {
                                    localStorage.setItem('token', data.authCode)
                                    this.loginByJwt(data.authCode, true)
                                } else {
                                    this.$message.error(data.msg)
                                }
                            })
                        } else {
                            this.$message.error(data.msg)
                        }
                    })
                } else {
                    this.$message.error(data.msg)
                }
            })
        },
        loginByJwt(token, is) {
            this.$http.post(`/oauth/tokenLogin?token=${token}`).then(({data}) => {
                if (data.code === '1') {
                    if(is) {
                        this.$http.post(`/auth/application/get?id=e090d9885a534dacb0e0103fd1cde816`).then(({data}) => {
                            if (data.code == 1) {
                                location.href = `${data.gatewayInfo}?token=${token}`
                            }
                        })
                    }
                    this.$http.post('/oauth2/authorize',{
                        clientId:this.oauthInfo.client_id,
                        scope:'login',
                        // loginId:'',
                        redirectUri:this.oauthInfo.redirect_uri,
                        responseType:'code',
                        state:this.oauthInfo.state
                    }).then((res) => {
                        let {data} = res;
                        if(data.code == '1') {
                            location.href = data.data;
                        }
                    })
                    // let url = this.$route.query.redirect_uri
                    // if (this.appCode != 1) {
                    //     if (is) {
                    //         this.$http.post(`/auth/application/get?id=e090d9885a534dacb0e0103fd1cde816`).then(({data}) => {
                    //             if (data.code == 1) {
                    //                 location.href = `${data.gatewayInfo}?token=${token}`
                    //             }
                    //         })
                    //     } else {
                    //         this.verifySys((is) => {
                    //             if (is) {
                    //                 location.href = `${url}?token=${token}`
                    //             } else {
                    //                 this.$router.push({name: 'unifyLogin'})
                    //             }
                    //         })
                    //     }
                    // } else {
                    //     this.$router.push({name: 'unifyLogin'})
                    // }
                } else {
                    this.$message.error(data.msg)
                }
            })
        },
        //在线客服
        onlineService() {
            (function (w, d, n, a, j) {
                // console.log(w, d, n, a, j)
                w[n] = w[n] || function () {
                (w[n].a = w[n].a || []).push(arguments)
                }
                j = d.createElement('script')
                j.async = true
                j.src = 'https://qiyukf.com/script/b61fe3153c3248dd1bda54718819c05e.js'
                d.body.appendChild(j)
            })(window, document, 'ysf')
        },
        //获取token
        getToken() {
            let logout = this.$route.query.logout
            if (logout === '1') {

            } else {
                let url = this.$route.query.redirect_uri
                this.$http.post(`/oauth/refleshToken`).then(({data}) => {
                    if (url && data.authCode) {
                        let token = data.authCode
                        if (this.appCode != 1) {
                            this.verifySys((is) => {
                                if (is) {
                                    location.href = `${url}?token=${token}`
                                } else {
                                    this.$router.push({name: 'unifyLogin'})
                                }
                            })
                        } else {
                            this.$router.push({name: 'unifyLogin'})
                        }
                    }
                })
            }
        },

        //验证权限
        verifySys(callback) {
            this.$http.post(`/oauth/verifyPerm?appId=${this.appCode}`).then(res => {
                if (res.data.code == 1) {
                    callback && callback(true)
                } else {
                    callback && callback(false)
                    // this.$message.error(res.data.msg)
                }
            })
        },
        //处理CA获取的时间
        formFilter(data) {
            var qyear = new Date().getFullYear()
            var q2year = qyear.toString().slice(0, 2)
            var time = q2year + data
            var year = time.substring(0, 4)
            var month = time.substring(4, 6)
            var date = time.substring(6, 8)
            var hour = time.substring(8, 10)
            var minute = time.substring(10, 12)
            var second = time.substring(12, 14)
            // console.log(time,year,month,date,hour,minute,second)
            return year + '-' + month + '-' + date + ' ' + hour + ':' + minute + ':' + second
        },
        //获取验证码
        getCaptcha() {
            this.dataForm.uuid = getUUID()
            console.log(this.dataForm)
            this.captchaPath = this.$http.adornUrl(`/sso/captchaCode.png?uuid=${this.dataForm.uuid}`)
        },
        noticeToUsers() { //用户须知
            this.$router.push('/register')
        },
        //获取平台帮助列表
        getPlatformHelp() {
            ssoHttp.post('/proxyApi/question-help/qa-list', {
                page: 1,
                rows: 10,
                filter: {
                key: ''
                },
                searchKey: '',
                orderBy: 'create_time desc'
            }).then(res => {
                this.questionList = res.data.rows
            })
        },
        toDetail(item, index) {
            let routeOne = this.$router.resolve({
                path: '/detailLogin',
                query: {id: item.id, index: index}
            })
            window.open(routeOne.href, '_blank')
        },
        other_login() {
            this.login_switch = false
            this.account_switch = true
            this.loginTypeActive = 3
            const showTime = 60 * 5
            // eslint-disable-next-line no-unused-vars
            let time = showTime
            let that = this
            that.$http.post(`/vaiwanSso/getRqCode`).then(res => {
                if (res.data.code === '1') {
                    that.imgurl = res.data.data.qrimage
                    that.qrid = res.data.data.qrid
                    time = showTime
                    const interCount = setInterval(function () {
                        time--
                        if (time === 0) {
                            clearInterval(interCount)
                            that.ShowMessage()
                        } else {
                            // that.$http.post(`/vaiwanSso/asynQuery?qrid=1310008abcd31110200000005121018GI4mA5SXA4839A73`).then(res => {
                            that.$http.post(`/vaiwanSso/asynQuery?qrid=${that.qrid}`).then(res => {
                                if (res.data.code === '1') {
                                    if (res.data.data.redirectUrl && res.data.data.redirectUrl !== '') {
                                        clearInterval(interCount)
                                        window.location.href = res.data.data.redirectUrl
                                    } else if (res.data.data.legalCode) {
                                        clearInterval(interCount)
                                        // window.location.href =
                                        ssoHttp.post('https://entinfo.lhjs.cn/proxyApi/register/save', {
                                            mainCode: res.data.data.legalCode,
                                            entName: res.data.data.orgName,
                                            mainType: 1
                                        }).then(res => {
                                            clearInterval(interCount)
                                            window.location.href = res.data.data.redirectUrl
                                        })
                                        // location.href = res.data.redirectUrl
                                    }
                                }
                            })
                        }
                    }, 1000 * 3)
                } else {
                    // this.$message.error(res.data.msg)
                }
            })
        },
        unified_login() {
            const that = this
            that.$http.post(`/epointSso/getEpointSsoUrl`).then((res) => {
                // eslint-disable-next-line no-console
                console.log(res, 'ddd')
                if (res.data.code === '1') {
                    window.location.href = res.data.data
                }
            })
        },
        account_login() {
            this.loginTypeActive = 0
            this.login_switch = true
            this.account_switch = false
        },
        ShowMessage() {
            this.$message.error('二维码已失效')
            this.other_login()
        }
    }
}
</script>

<style lang="scss" scoped>
.container {
    background: url("../../assets/img/lh-login/login_bg.png") no-repeat;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    /deep/ .el-input__inner {
        background: #FFFFFF;
        height: 44px;
        border: 1px solid #1890FF;
        border-radius: 3px;
    }

    /deep/ .el-form-item {
        margin-bottom: 25px;
    }

    /deep/ .el-dialog__body {
        padding: 10px 40px 70px 40px;
    }

    header {
        width: 100%;
        height: 100px;
    }

    .user-type {
        display: flex;
        align-items: center;

        span {
            padding: 5px 10px;
            cursor: pointer;
        }
    }

    section {
        width: 1200px;
        background-size: 100% 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        h4 {
            font-size: 32px;
            font-weight: bold;
            color: #FFFFFF;
            margin: 0 0 24px 0;
        }

        .center-cont {
            height: 480px;
            display: flex;
            border-radius: 2px;
            box-shadow: 0px 0px 30px 0px rgba(70, 127, 221, 0.4);
            background: #ffffff;

            .login_box {
                width: 490px;
                height: 100%;

                display: flex;
                flex-direction: column;
                justify-content: space-between;
                padding: 28px 0;

                .login_title {
                    width: 100%;
                    height: 40px;
                    border-bottom: 3px solid #eeeeee;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    span {
                        height: 100%;
                        padding: 0 20px;
                        border-bottom: 3px solid #eeeeee;
                        margin-bottom: -6px;
                        font-size: 18px;
                        cursor: pointer;
                    }

                    span.active {
                        border-bottom: 3px solid #1890FF;
                        margin-bottom: -6px;
                        color: #1890FF;
                    }
                }

                .notice {
                    span {
                        color: #1890FF
                    }
                }

                .notice:focus, .notice:hover {
                    color: #1890FF;
                }

                .login-type {
                    width: 100%;
                    height: 290px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                }

                .login_cont {
                    width: 80%;
                    height: 180px;
                    border: 1px solid #CCCCCC;
                    background: url("../../assets/img/lh-login/login_cont.png") no-repeat center center;
                    margin: 20px 0;
                }

                .login_QRcode {
                    width: 220px;
                    height: 220px;

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }

                .login-input {
                    width: 86%;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;

                    p {
                        span {
                            font-weight: bold;
                        }
                    }
                }

                .login-code {
                    width: 80%;
                    height: 180px;

                }

                button {
                    width: 100%;
                    background: #1890FF;
                    border: 0;
                    outline: 0;
                    height: 56px;
                    border-radius: 3px;
                    color: #ffffff;
                    cursor: pointer;
                }

                button:hover {
                /*box-shadow: 0 0 1px 1px rgba(0, 0, 0, .5);*/
                }
            }

            .center-tips {
                width: 305px;
                height: 100%;
                color: #1890FF;
                padding: 0 15px;
                //background: rgba(255, 255, 255, .3);
                background: url('~@/assets/img/tips.png') center center no-repeat;
                background-size:cover; 
                h4 {
                    font-size: 16px;
                    font-weight: bold;
                    margin: 20px 0;
                    padding: 0 9px;
                    color: #1890FF;
                }

                ul {
                    width: 100%;
                    height: 270px;

                    li {
                        width: 260px;
                        height: 27px;
                        line-height: 27px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        cursor: pointer;
                        text-align: left;

                        i {
                            display: inline-block;
                            width: 3px;
                            height: 3px;
                            background: rgba(24, 144, 255, 0.85);
                            margin: 0 9px 3px 9px;
                        }
                    }
                }

                p {
                    padding: 0 9px;
                    margin: 30px 0 0 0;

                    a {
                        span {
                            padding: 13px;
                            font-size: 14px;
                            font-weight: 400;
                            display: flex;
                            align-items: center;
                            cursor: pointer;
                            justify-content: center;

                            i {
                                width: 14px;
                                height: 14px;
                                margin: 0 8px 0 0;
                            }
                        }
                    }

                    a:focus, a:hover {
                        text-decoration: none;
                    }

                    a:nth-child(1) {
                        span {
                            background: rgba(255, 255, 255, 0.5);
                            border: 1px solid #1890FF;
                            border-radius: 2px;
                            color: #1890FF;

                            i {
                                background: url("../../assets/img/lh-login/login-icon-1.png") no-repeat center;
                            }
                        }
                    }

                    a:nth-child(1):focus, a:nth-child(1):hover {
                        span {
                            background: rgba(255, 255, 255, 0.5);
                            border: 1px solid #1890FF;
                            border-radius: 2px;
                            background: #1890FF;
                            color: #fff;

                            i {
                                background: url("../../assets/img/lh-login/login-icon-1-1.png") no-repeat center;
                            }
                        }
                    }

                    a:nth-child(2) {
                        span {
                            background: rgba(255, 255, 255, 0.5);
                            border: 1px solid #FE8F3B;
                            border-radius: 2px;
                            color: #FE8F3B;

                            i {
                                background: url("../../assets/img/lh-login/login-icon-2.png") no-repeat center;
                            }
                        }
                    }

                    a:nth-child(2):focus, a:nth-child(2):hover {
                        span {
                            background: rgba(255, 255, 255, 0.5);
                            border: 1px solid #FE8F3B;
                            border-radius: 2px;
                            background: #FE8F3B;
                            color: #fff;

                            i {
                                background: url("../../assets/img/lh-login/login-icon-2-1.png") no-repeat center;
                            }
                        }
                    }
                }
            }

            .other_login_way {
                .other_login_tips {
                    display: flex;
                    width: calc(100% - 80px);
                    align-items: center;
                    justify-content: space-between;
                    margin: 0 auto 10px;

                    .line_left {
                        width: 35%;
                        height: 1px;
                        background-image: linear-gradient(to right, #ccc 0%, #ccc 50%, transparent 50%);
                        background-size: 8px 1px;
                        background-repeat: repeat-x;
                    }

                    .line_right {
                        width: 35%;
                        height: 1px;
                        background-image: linear-gradient(to right, #ccc 0%, #ccc 50%, transparent 50%);
                        background-size: 8px 1px;
                        background-repeat: repeat-x;
                    }
                }

                .login_choose {
                    display: flex;
                    width: calc(100% - 80px);
                    align-items: center;
                    justify-content: space-around;
                    margin: auto;

                    .unified_login, .other_login {
                        color: #1890FF;
                        cursor: pointer;
                    }
                }

            }
        }

    }

    .step-tips {
        width: 100%;
        height: 50px;
        text-align: center;
        line-height: 50px;
        font-size: 14px;
        font-weight: bold;
        color: #FFFFFF;
        background-image: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, .1), rgba(0, 0, 0, .1), rgba(0, 0, 0, 0));
        margin: 10px 0 0 0;
    }

    footer {
        width: 100%;
        height: 100px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        p {
            margin: 10px;
            font-weight: bold;
        }
    }
}

</style>
